import { render, staticRenderFns } from "./BusinessAdd.vue?vue&type=template&id=1e04a9d8&scoped=true&"
import script from "./BusinessAdd.vue?vue&type=script&lang=js&"
export * from "./BusinessAdd.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAdd.vue?vue&type=style&index=0&id=1e04a9d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e04a9d8",
  null
  
)

export default component.exports